module.exports = __webpack_public_path__ + "static/media/bookmark.848018f6.svg";